import type { LogicalFilter, LogicalOperator } from '@hello-aria/query-string'
import type { ComparisonFilterInput, NestedLogicalFilterInput } from '@hello-aria/query-string/dist/stringify'
import { isArray, isEmpty, isNil } from 'lodash'
import type { Loan, LoanStatus } from '@/shared/models/loanModels'
import { STATUSES_EXEMPT_FROM_INVOICE_REQUIREMENT } from '@/shared/models/loanModels'

export const getCountByStatus = (
    loans: Pick<Loan, 'amount' | 'status'>[] | null | undefined,
    status: LoanStatus | LoanStatus[]
): number => {
    if (isNil(loans) || isEmpty(loans)) {
        return 0
    }

    return loans.reduce((acc, loan) => {
        const shouldCount = isArray(status) ? status.includes(loan.status) : loan.status === status
        return shouldCount ? acc + 1 : acc
    }, 0)
}

export const getAmountByStatus = (
    loans: Pick<Loan, 'amount' | 'status'>[] | null | undefined,
    status: LoanStatus | LoanStatus[]
): number => {
    if (isNil(loans) || isEmpty(loans)) {
        return 0
    }

    return loans.reduce((acc, loan) => {
        const shouldCount = isArray(status) ? status.includes(loan.status) : loan.status === status
        return shouldCount ? acc + loan.amount : acc
    }, 0)
}

export interface ResolveLoansFilters {
    type: LogicalFilter['type']
    operator: LogicalOperator
    filters: (
        | ComparisonFilterInput
        | {
              type: LogicalFilter['type']
              operator: LogicalOperator
              filters: ComparisonFilterInput[]
          }
    )[]
}

export type ResolveLoansFiltersParams = {
    customFilters?: (ComparisonFilterInput | NestedLogicalFilterInput)[]
}

export const resolveLoanFilters = ({ customFilters }: ResolveLoansFiltersParams): ResolveLoansFilters => {
    const filters: (ComparisonFilterInput | NestedLogicalFilterInput)[] = customFilters ?? []

    return {
        type: 'logical',
        operator: 'and',
        filters
    }
}

export const shouldDisplayInvoiceWarnings = (status: LoanStatus | undefined): boolean => {
    if (!status) return true
    return !STATUSES_EXEMPT_FROM_INVOICE_REQUIREMENT.includes(status)
}
